import { atom } from 'recoil';

import {
  carrierButtons,
  equalButtons,
  existButtons,
  productButtons,
  speedButtons,
} from '@components/internet/InternetServiceMocks';

export const accessTokenState = atom<string | undefined>({
  key: 'accessTokenState',
  default: undefined,
});

export const homecleanState = atom({
  key: 'homecleanState',
  default: {
    isHomeclean: false,
    isHomecleanIframeExpanded: false,
  },
});

export const internetState = atom({
  key: 'internetState',
  default: {
    product: productButtons[1],
    speed: speedButtons[0],
    carrier: carrierButtons[0],
    equal: equalButtons[0],
    exist: existButtons[0],
  },
});

export const internetProductState = atom({
  key: 'internetProductState',
  default: productButtons,
});

export const internetSpeedState = atom({
  key: 'internetSpeedState',
  default: speedButtons,
});
